import { useEffect } from 'react'


const QRPluckingRooster = ({ data, isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])
    

    return (
        <>
            <div className='SelfieFan__Screen__QR__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='SelfieFan__Screen__Selfie__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='SelfieFan__Screen__Selfie__Background__Image' />
                )}
            </div>

            <div className='SelfieFan__Screen__QR__Box SelfieFan__Screen__QR__Up'>
                <div className='SelfieFan__Screen__QR__Container'>
                    <div className='SelfieFan__Screen__QR__Container__Instructions'>
                        <img src="/img/page/xolos-five.png" className="SelfieFan__Screen__QR__Container__Instructions__Logo" alt="Logo" />
                        {/* <p className='SelfieFan__Screen__QR__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>ESCANEA EL CÓDIGO Y PARTICIPA POR UN REGALO ESPECIAL</p> */}
                        <p className='SelfieFan__Screen__QR__Container__Instructions__Text'>ESCANEA EL CÓDIGO Y JUEGA</p>
                    </div>
                    
                    <img src='/img/page/qr/pluckingrooster-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__QR__Container__QR' />
                </div>
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    )
}

export { QRPluckingRooster };